import { render } from "./RemoteTreeSelect.vue?vue&type=template&id=4c539104"
import script from "./RemoteTreeSelect.vue?vue&type=script&lang=ts"
export * from "./RemoteTreeSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script